<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div class="rate-wrap">
        <div class="rate">
          <star-rating
            v-model.number="fieldValue"
            :border-width="2"
            :rounded-corners="true"
            :star-points="[
              23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46,
              19, 31, 17,
            ]"
            :star-size="22"
            active-color="#fdcf6e"
            border-color="transparent"
            text-class="hidden"
          />
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import StarRating from "vue-star-rating";

export default {
  name: "FormRatingField",

  components: {
    StarRating,
  },

  mixins: [FieldMixin],

  created() {
    if (this.fieldValue === undefined) {
      this.fieldValue = 0;
    }
  },
};
</script>
